export default __webpack_public_path__ + "static/media/Tess_9781408308189.5351bab3.jpg";